import { admGraphqlRequest, aomGraphqlRequest } from 'core/utils/backend-service';
import { UserCustomFilterApi, UserPreferencesApi } from 'core/utils/types/user-custom-filter.type';
import { mapAppSettingsFromApiToModel, VM } from './domain';
import {
    mapFilterAlarmsFromAPIToModel,
    mapOperatorFilterAlarmsFromAPIToModel,
} from './domain/mappers/side-menu-alarm.mapper';
import {
    getDeviceFilterAlarmsQuery,
    getOperatorFilterAlarmsQuery,
    getUserPreferences as getUserPreferencesQuery,
    removeFilterFromUserById,
    saveTableRowsPerPage as saveTableRowsPerPageQuery,
    saveUserFilter,
    updateUserFilter,
} from './user-preferences.queries';

export const getUserPreferences = async (): Promise<{
    appSettingsConfig: VM.AppSettingsConfig;
    userPreferences: UserPreferencesApi;
}> =>
    aomGraphqlRequest(getUserPreferencesQuery()).then((result) => ({
        appSettingsConfig: mapAppSettingsFromApiToModel(result.data.appSettingsConfig),
        userPreferences: result.data.userPreferences as UserPreferencesApi,
    }));

export const getOperatorFilterAlarms = async (): Promise<Record<string, VM.SideMenuAlarm>> =>
    aomGraphqlRequest(getOperatorFilterAlarmsQuery(), {}, false).then((result) =>
        mapOperatorFilterAlarmsFromAPIToModel(result.data.retrieveSavedViewAlarms)
    );

export const getDeviceFilterAlarms = async (): Promise<Record<string, VM.SideMenuAlarm>> =>
    admGraphqlRequest(getDeviceFilterAlarmsQuery(), {}, false).then((result) =>
        mapFilterAlarmsFromAPIToModel(result.data.deviceAlarmNumbers)
    );

export const deleteFilterFromUserPreferences = async (filterId: string): Promise<{ result: string }> =>
    aomGraphqlRequest(removeFilterFromUserById(), { filterId }).then(() => ({ result: 'ok' }));

export const saveFilterToUserPreferences = async <T>(
    userPreferencesId: string,
    filter: UserCustomFilterApi<T>
): Promise<{ filterId: string }> =>
    aomGraphqlRequest(saveUserFilter(), {
        userPreferencesId,
        filterName: filter.filterName,
        filterType: filter.type,
        frontendData: JSON.stringify(filter.frontendData),
        queryData: filter.queryData,
    }).then((response) => ({ filterId: response.data.saveFilter.filterId }));

export const updateFilterFromUserPreferences = async <T>(
    userPreferencesId: string,
    filter: UserCustomFilterApi<T>
): Promise<{ result: string }> =>
    aomGraphqlRequest(
        updateUserFilter(),
        {
            userPreferencesId,
            filterId: filter.filterId,
            filterName: filter.filterName,
            frontendData: JSON.stringify(filter.frontendData),
            queryData: filter.queryData,
        },
        false
    ).then(() => ({ result: 'ok' }));

export const saveTableRowsPerPage = async (
    userPreferencesId: string,
    pageSize: number,
    target: VM.RowsPerPageTarget
): Promise<{ result: string }> =>
    aomGraphqlRequest(saveTableRowsPerPageQuery(), {
        rowsPerPage: { userPreferencesId, rowsPerPage: pageSize, target },
    }).then(() => ({ result: 'ok' }));
